import { useCallback } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const usePopover = () => {
  const startHighlight = useCallback((element) => {
    if (!element) return; // Prevent errors if no element is passed
  
    const {elementId, elementTitle, elementDescription}= element || {}
    if (!elementId && elementTitle && elementDescription) return;

    const tour = driver({
      stagePadding: 4,
    });

    tour.highlight({
      element: `#${elementId}`,
      popover: {
        side: "bottom",
        title: elementTitle,
        description: elementDescription,
      },
    });
  }, []);

  return { startHighlight };
};

export default usePopover;
